import React from "react";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { BatteryIntro } from "./BatteryIntro";
import { BatteryManufacturerSelection } from "./BatteryBrandSelection";
import { UnsupportedBattery } from "./UnsupportedBattery";
import { BatteryConclusion } from "./BatteryConclusion";

export type ConnectBatteryRoutesProps = {
  onComplete?: (reason: string) => void;
  closeElement?: React.ReactElement;
};

export function ConnectBatteryRoutes({
  onComplete,
  closeElement,
}: ConnectBatteryRoutesProps) {
  return (
    <Routes>
      <Route
        path="devices/link-battery/intro"
        element={<BatteryIntro onComplete={onComplete} />}
      />
      <Route
        path="devices/link-battery/manufacturer"
        element={<BatteryManufacturerSelection onComplete={onComplete} />}
      />
      <Route
        path="devices/link-battery/unsupported"
        element={<UnsupportedBattery onComplete={onComplete} />}
      />
      <Route
        path="devices/link-battery/conclusion"
        element={<BatteryConclusion onComplete={onComplete} />}
      />
      <Route index element={<ConnectBatteryDefaultRoute />} />
      {closeElement && <Route path="*" element={closeElement} />}
    </Routes>
  );
}

function ConnectBatteryDefaultRoute() {
  const [searchParams] = useSearchParams();
  const searchParamsString = searchParams.toString();

  // Always start at intro, preserving any query parameters
  const destination = searchParamsString
    ? `/devices/link-battery/intro?${searchParamsString}`
    : "/devices/link-battery/intro";

  return <Navigate to={destination} replace />;
}
